{
    "MainmenuPinmenu": "Pin-Menü",
    "MainmenuPinnedmenu": "Menü lösen",
    "MainmenuHome": "Heim",
    "MainmenuMoreoptions": "Mehr Optionen",
    "MainmenuWhatisnew": "Was gibt's Neues?",
    "MainmenuOmnichannelPanel": "Omnichannel-Panel",
    "MainmenuPrivacynotice": "Datenschutzerklärung",
    "MainMenuCookiePolicy": "Cookie-Richtlinie",
    "MainmenuTermsofservice": "Nutzungsbedingungen",
    "MainmenuSetlanguage": "Sprache einstellen",
    "MainmenuHelp": "Hilfe",
    "MainmenuChangePassword": "Passwort ändern",
    "MainmenuServerInfo": "Server-Info",
    "MainmenuSendfeedback": "Senden Sie uns Ihr Feedback!",
    "MainmenuButtonTitleAddreport": "Neuen Bericht hinzufügen",
    "MainmenuButtonTitleDeletereport": "Bericht löschen",
    "MainmenuButtonTitlePermanentlyDeletereport": "Bericht dauerhaft löschen",
    "MainmenuButtonSubTitleDisabled": "(Wählen Sie einige Berichte aus, um diese Option zu verwenden)",
    "NAME": "LanguageMainMenu",
    "MainMenu_RestartTour": "Neustart der Tour",
    "MAIN_MENU_SETTINGS_CLEAR_CONTENTFUL_CACHE": "Inhalts-Cache löschen",
    "MainMenu_Turn_On_Insights_Hub": "Insights Dashboard einschalten",
    "MainMenu_Turn_Off_Insights_Hub": "Insights Dashboard ausschalten",
    "MainMenu_Timezone": "Zeitzone ändern"
}